export default __webpack_public_path__ + "static/media/laptop-for-business-student.35d3007e.png";